// eslint-disable-next-line import/prefer-default-export
export enum ProductInviteType {
	NEW_PROFILE_CREATION = 1,
	CONNECT_EXISTING_PROFILE = 2,
}
